import React from 'react';
import { Plus } from 'lucide-react';

import { orderItemCardId } from '../../../OrderForm/constants';
import { useSteelItems } from '../contexts/SteelItemsContext';
import { ItemsSection } from '../Sections/Items/index';
import { AddNewItemButton, Button, Card } from '../style';

const SteelItemsSlot: React.FC = () => {
  const {
    fields, removeItem, updateItem, addNewItem,
    collapsedItems, toggleItem,
    hasValidationError, noSavedItemsType,
  } = useSteelItems();

  const missingItems = hasValidationError && noSavedItemsType === 'no-items';

  return (
    <>
      {fields.map((field, index: number) => (
        <Card key={field.id} id={orderItemCardId(index)}>
          <ItemsSection
            index={index}
            onDelete={() => removeItem(index)}
            updateItem={updateItem}
            isCollapsed={collapsedItems.has(index)}
            onToggle={(forceOpen?: boolean) => toggleItem(index, forceOpen)}
            itemOptionsFromApi={[]}
            formatOptionsList={[]}
            finishingOptionsList={[]}
            highlightSaveButton={hasValidationError && noSavedItemsType === 'not-saved'}
          />
        </Card>
      ))}

      <AddNewItemButton>
        <Button
          type="button"
          variant="outline"
          onClick={addNewItem}
          style={{
            borderColor: missingItems ? '#F87171' : undefined,
            borderWidth: missingItems ? '2px' : undefined,
          }}
        >
          <Plus size={16} />
          Adicionar Novo Item
        </Button>
      </AddNewItemButton>
    </>
  );
};

export default SteelItemsSlot;
